import React from "react";
import { useLocation } from "../LocartionContext";

const LocationBanner = () => {
  const { location, setShowPopup } = useLocation();

  if (!location) return null;

  return (
    <div
      className="location-banner"
      style={{
        position: "sticky",
        top: 0,
        zIndex: 60,
        background: "#fcc234",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "0.5rem",
        padding: "0.4rem 1rem",
        borderBottom: "1.5px solid #e0b820",
      }}
    >
      {/* Pin icon */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#000"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ flexShrink: 0 }}
      >
        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
        <circle cx="12" cy="10" r="3" />
      </svg>

      <span
        style={{
          fontFamily: "'kingthings_trypewriter_2Rg', serif",
          fontSize: "clamp(0.7rem, 2vw, 0.82rem)",
          color: "#000",
          letterSpacing: "1px",
          fontWeight: 800,
          WebkitTextStroke: "0.3px",
        }}
      >
        YOUR LOCATION:{" "}
        <strong style={{ letterSpacing: "1.5px" }}>
          {location.address}, {location.city}
        </strong>
      </span>

      <button
        onClick={() => setShowPopup(true)}
        style={{
          marginLeft: "0.5rem",
          fontFamily: "'kingthings_trypewriter_2Rg', serif",
          fontSize: "0.7rem",
          fontWeight: 800,
          letterSpacing: "1.5px",
          textTransform: "uppercase",
          color: "#000",
          background: "rgba(0,0,0,0.1)",
          border: "1.5px solid rgba(0,0,0,0.25)",
          borderRadius: "20px",
          padding: "2px 10px",
          cursor: "pointer",
          transition: "all 0.2s ease",
          WebkitTextStroke: "0.3px",
          whiteSpace: "nowrap",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = "rgba(0,0,0,0.2)";
          e.currentTarget.style.borderColor = "rgba(0,0,0,0.5)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = "rgba(0,0,0,0.1)";
          e.currentTarget.style.borderColor = "rgba(0,0,0,0.25)";
        }}
      >
        Change
      </button>
    </div>
  );
};

export default LocationBanner;
